import * as React from 'react'

const ErrorLabel = ({error}) => {
  return (
    <div className='tw-mt-1 tw-text-xs tw-text-red-500 '>{error}</div>
  )
}

export default ErrorLabel